import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridCellContext, GridTemplateComponent } from '@common/interfaces/column-settings.interface';
import { TicketListModel } from '../models/ticket-list.model';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { NgIconComponent } from '@ng-icons/core';

@Component({
    standalone: true,
    imports: [CommonModule, TranslateModule, TooltipsModule, NgIconComponent],
    template: `
        <div class="inline-flex items-center gap-2">
            @if (active) {
                <span class="inline-block h-3 w-3 rounded-full bg-success"
                      kendoTooltip
                      title="{{ 'Active' | translate }}"></span>
            } @else {
                <span class="inline-block h-3 w-3 rounded-full bg-danger"
                      kendoTooltip
                      title="{{ remark || ('Deactivated' | translate) }}"></span>
                @if (remark) {
                    <ng-icon name="faSolidCircleInfo"
                             class="text-xs text-muted"
                             kendoTooltip
                             title="{{ remark }}"></ng-icon>
                }
            }
        </div>
    `
})
export class TicketActiveCellComponent implements GridTemplateComponent<TicketListModel> {
    context: GridCellContext<TicketListModel>;
    @Input() active: boolean;
    @Input() remark?: string;
}
